require('sass/brands/stores.petit-bateau.com/directory/default.scss');
require('js/stateList-script.js');
